import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "label", "panel"]

  toggle() {
    const expanded = this.buttonTarget.getAttribute("aria-expanded") === "true"

    this.buttonTarget.setAttribute("aria-expanded", String(!expanded))
    this.labelTarget.textContent = expanded ? "See the full 5-vs-5 comparison" : "Show fewer results"
    this.element.classList.toggle("is-expanded", !expanded)

    requestAnimationFrame(() => {
      const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"

      this.panelTarget.scrollIntoView({ behavior, block: "start" })
    })
  }
}
